import _slicedToArray from "E:/guanwnag/hzzn.group.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2736f4c0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "footer-box"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "footer-contact"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "width-auto"
  }, "联系我们")], -1);
});

var _hoisted_3 = {
  class: "footer-content"
};
var _hoisted_4 = {
  class: "contact-box width-auto"
};
var _hoisted_5 = {
  class: "qr-code"
};
var _hoisted_6 = ["src"];

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "汇智互娱公众号", -1);
});

var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "version-box",
  style: {
    "display": "flex",
    "align-items": "center",
    "cursor": "default"
  }
};
var _hoisted_10 = ["onClick"];

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Copyright2024", -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "南京汇智互娱网络科技有限公司", -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "公司地址：南京市雨花台区软件大道178号汇智城C座3层", -1);
});

import { reactive, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import FeedBackModal from '@/components/feedbackModal.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var list = reactive([// { title: '商户合作', desc: 'business@huizhihuyu.com' },
    // { title: '服务热线', desc: '13382794187' },
    // { title: '官方QQ', desc: '1703464024' },
    {
      title: '公司地址',
      desc: '南京市雨花台区软件大道178号汇智城C座3层'
    }]); // 根据域名获取备案号（域名包含匹配）

    var recordNumber = computed(function () {
      var hostname = window.location.hostname;
      var domainMap = {
        'huizhihuyu.com': '苏ICP备17041748号-1',
        'jingjingyouxi.com': '苏ICP备17041748号-2',
        'shouyoufuwu.com': '苏ICP备17041748号-3',
        'huiyouxi.com': '苏ICP备17041748号-4',
        'cest2020.com': '苏ICP备17041748号-5',
        'chinacest.com': '苏ICP备17041748号-6',
        'juhuatian.com': '苏ICP备17041748号-8',
        'you18.com': '苏ICP备17041748号-9'
      }; // 遍历域名映射，查找包含关键字的域名

      for (var _i = 0, _Object$entries = Object.entries(domainMap); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            domain = _Object$entries$_i[0],
            record = _Object$entries$_i[1];

        if (hostname.includes(domain)) {
          return record;
        }
      }

      return '苏ICP备17041748号-1';
    });

    function handleJumpHref() {
      // window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
    }

    function handlePact() {
      router.push('/pact');
    }

    var goUrl = function goUrl(url) {
      window.open(url, "_blank");
    };

    var feedbackModalShow = ref(false);

    var feedBack = function feedBack() {
      feedbackModalShow.value = true;
    };

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('hzqr_img@2x.png'),
        alt: ""
      }, null, 8, _hoisted_6), _hoisted_7]), _createElementVNode("div", {
        class: "pact",
        onClick: _withModifiers(handlePact, ["stop", "prevent"])
      }, "汇智互娱平台自律公约", 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", {
        style: {
          "cursor": "pointer"
        },
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return goUrl('https://uvisyn41q4.feishu.cn/wiki/Q3X9wUuoZi8ASJks6mqcBDycn8f');
        })
      }, "服务协议"), _createElementVNode("span", {
        style: {
          "margin-right": "10px",
          "cursor": "pointer"
        },
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return goUrl('https://uvisyn41q4.feishu.cn/wiki/IpFuwdBvMimNXnkF5VqcNvyRnbf');
        })
      }, "隐私协议"), _createElementVNode("span", {
        style: {
          "margin-right": "10px",
          "cursor": "pointer"
        },
        onClick: feedBack
      }, "意见反馈"), _createElementVNode("div", {
        class: "version-box",
        style: {
          "margin-top": "0"
        },
        onClick: _withModifiers(handleJumpHref, ["stop", "prevent"])
      }, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_unref(recordNumber)), 1), _hoisted_12, _hoisted_13], 8, _hoisted_10)])])]), _createVNode(FeedBackModal, {
        show: feedbackModalShow.value,
        "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
          return feedbackModalShow.value = $event;
        })
      }, null, 8, ["show"])]);
    };
  }
});